var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"text-caption",attrs:{"color":"transparent","flat":"","dense":"","height":"28px"}},[_c('v-spacer'),_c('div',{staticClass:"text-centers"},[_vm._v(" Powered by "),_c('a',{attrs:{"href":"https://restion.ru","target":"_blank"}},[_vm._v("RESTION")])]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }